// utils/fieldFactory.ts

import { v4 as uuidv4 } from "uuid";
import {
  SurveyItem,
  QuestionData,
  QuestionType,
  SectionData,
  Answer,
  QuestionOptions,
} from "../types/survey";

export const createId = () => uuidv4();

const createEmptyAnswer = (sort: number = 0): Answer => ({
  id: createId(),
  title: "",
  sort,
  options: {
    enabled: true,
  },
  logic: [],
});

const createToggleAnswers = (): Answer[] => [
  {
    id: createId(),
    title: "Yes",
    sort: 0,
    options: { enabled: true },
    logic: [],
  },
  {
    id: createId(),
    title: "No",
    sort: 1,
    options: { enabled: true },
    logic: [],
  },
];

const createSelectAnswers = (count: number = 2): Answer[] => {
  return Array.from({ length: count }, (_, i) => createEmptyAnswer(i));
};

export const fieldFactory = {
  question(questionType: QuestionType, sort: number = 0): SurveyItem {
    const questionOptions: QuestionOptions = {
      enabled: true,
    };

    switch (questionType) {
      case "text":
        questionOptions.multiline = false;
        questionOptions.maxLength = 255;
        break;
      case "number":
        questionOptions.minLength = 0;
        break;
    }

    const questionData: QuestionData = {
      id: createId(),
      type: undefined,
      title: "",
      sort: 0,
      required: false,
      options: questionOptions,
      logic: [],
      answers: [],
    };

    switch (questionType) {
      case "toggle":
        questionData.answers = createToggleAnswers();
        break;
      case "singleSelect":
      case "multiSelect":
        questionData.answers = createSelectAnswers(2);
        break;
    }

    return {
      id: createId(),
      sort,
      question: questionData,
      section: null,
    };
  },

  section(sort: number = 0): SurveyItem {
    const sectionData: SectionData = {
      id: createId(),
      title: "",
      sort: 0,
      questions: [],
      isRepeatable: false,
    };

    return {
      id: createId(),
      sort,
      question: null,
      section: sectionData,
    };
  },

  questionInSection(
    questionType: QuestionType,
    sort: number = 0,
  ): QuestionData {
    const questionOptions: QuestionOptions = {
      enabled: true,
    };

    switch (questionType) {
      case "text":
        questionOptions.multiline = false;
        questionOptions.maxLength = 255;
        break;
      case "number":
        questionOptions.minLength = 0;
        break;
    }

    const questionData: QuestionData = {
      id: createId(),
      type: undefined,
      title: "",
      sort,
      required: false,
      options: questionOptions,
      logic: [],
      answers: [],
    };

    switch (questionType) {
      case "toggle":
        questionData.answers = createToggleAnswers();
        break;
      case "singleSelect":
      case "multiSelect":
        questionData.answers = createSelectAnswers(2);
        break;
    }

    return questionData;
  },
};
